import React, { Component } from 'react';
import Paper from 'material-ui/Paper';

export default (props) => {
  const style = {
    card: {
      ...props.style,
      height: 150,
      width: 250,
      margin: 20,
      padding: 5,
      borderRadius: 5,
      textAlign: 'center',
      display: 'inline-block',
      backgroundColor: props.background || 'white',
      color: props.color || 'black',
    },
    title: {
      fontSize: 32,
      marginTop: 20,
    }
  };

  return (
    <Paper style={style.card} zDepth={1}>
      <div style={style.title}>{props.value}</div>
      <div>{props.label}</div>
    </Paper>
  )
}



// WEBPACK FOOTER //
// ./src/components/StatCard.js